module.exports = __webpack_public_path__ + "static/media/building2.798aac2c.png";